import { useContext } from "react";
import UserRelationContext from "../contexts/UserRelationContext";

const useUserRelation = () => {
  return useContext(UserRelationContext);
};

export default useUserRelation;
